/* eslint-disable max-len */
/* eslint-disable react/no-unknown-property */
/* jscs:disable maximumLineLength */
import React, { PureComponent } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import PropTypes from 'prop-types';

class Twitter extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
  };

  render = () => (
    <SvgIcon width="20px" height="17px" viewBox="0 0 20 17" className={this.props.className}>
      <title>Twitter Icon</title>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Social-Icon-Set" transform="translate(-42.000000, -2.000000)" fill="#414f60">
          <g id="Group-2">
            <g id="Twitter-20x20" transform="translate(42.000000, 2.000000)">
              <path d="M19.4483753,0.30811951 C18.6548474,0.78978987 17.7780151,1.14009559 16.8408405,1.3275305 C16.0943049,0.510506501 15.0273676,0 13.8461538,0 C11.5819828,0 9.74447975,1.88396123 9.74447975,4.20740662 C9.74447975,4.53742023 9.77972392,4.8572878 9.85021227,5.16540731 C6.44007156,4.98972045 3.41708274,3.31669025 1.39214482,0.767895763 C1.03863509,1.39161082 0.8367821,2.11518436 0.8367821,2.88575014 C0.8367821,4.34464529 1.56088965,5.6326596 2.66253705,6.3872053 C1.99076175,6.3669132 1.35690065,6.17574026 0.802605933,5.86281473 L0.802605933,5.91407898 C0.802605933,7.95343497 2.21717886,9.65476731 4.09580007,10.0397832 C3.75190238,10.1385737 3.38878061,10.1882359 3.01444477,10.1882359 C2.75011348,10.1882359 2.49219021,10.1626038 2.24227699,10.1134756 C2.76453155,11.7843697 4.27896297,13.0013617 6.07481377,13.0339359 C4.67092089,14.1628174 2.90070221,14.8356607 0.978826796,14.8356607 C0.647745174,14.8356607 0.32040157,14.8164366 0,14.7779884 C1.8156089,15.9698823 3.97351347,16.6667557 6.29001682,16.6667557 C13.8381438,16.6667557 17.964382,10.2565883 17.964382,4.69601901 C17.964382,4.51285611 17.961178,4.33022722 17.954236,4.15080234 C18.7557739,3.55752543 19.4521133,2.8168638 20,1.97313967 C19.2652124,2.30742531 18.4738205,2.53384242 17.6439805,2.63530291 C18.4914426,2.11518436 19.1418578,1.29068432 19.4483753,0.30811951" />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default Twitter;
